/* tslint:disable */
import {
  App
} from '../index';

declare var Object: any;
export interface MenuitemInterface {
  index: string;
  label: string;
  linktype: string;
  link: string;
  pagelayout?: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
}

export class Menuitem implements MenuitemInterface {
  index: string;
  label: string;
  linktype: string;
  link: string;
  pagelayout: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  constructor(data?: MenuitemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Menuitem`.
   */
  public static getModelName() {
    return "Menuitem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Menuitem for dynamic purposes.
  **/
  public static factory(data: MenuitemInterface): Menuitem{
    return new Menuitem(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Menuitem',
      plural: 'menuitems',
      properties: {
        index: {
          name: 'index',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        linktype: {
          name: 'linktype',
          type: 'string'
        },
        link: {
          name: 'link',
          type: 'string'
        },
        pagelayout: {
          name: 'pagelayout',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Menuitem.ts